module.exports = __webpack_public_path__ + "static/media/protege_tus_datos_2.56346c7c.png";